import React from "react";
import { Grid, Typography } from "@mui/material";

const HistorySidebarHeader = () => {
  return (
    <Grid
      container
      alignItems="center"
      sx={{ py: 0.5, fontWeight: "bold", bgcolor: "grey.100", px: 0.5, borderRadius: 1, mb: 1 }}
      spacing={0.5}
    >
      <Grid item xs={0.4}></Grid>
      <Grid item xs={0.6}></Grid>
      <Grid item xs={2.8}>
        <Typography variant="body2" fontWeight={600} sx={{ fontSize: 14 }}>
          商品名
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography variant="body2" fontWeight={600} sx={{ fontSize: 14 }}>
          産地
        </Typography>
      </Grid>
      <Grid item xs={2.2}>
        <Typography variant="body2" fontWeight={600} sx={{ fontSize: 14 }}>
          規格
        </Typography>
      </Grid>
      <Grid item xs={1.5}>
        <Typography variant="body2" fontWeight={600} sx={{ fontSize: 14 }}>
          重量
        </Typography>
      </Grid>
      <Grid item xs={2.5} sx={{ textAlign: "center" }}>
        <Typography variant="body2" fontWeight={600} sx={{ fontSize: 14 }}>
        </Typography>
      </Grid>
    </Grid>
  );
};

export default HistorySidebarHeader;
